<template>

  <div class="page">

    <div class="top"></div>

  <!-- block开始 -->
  <div class="content-block">

    <div class="main">

      <div class="choose">
        <div class="gka-wrap">
            <div id="gka" class="chooseanimation"></div>
        </div>
      </div>

      <div class="bg">

        <div class="btn-switch-left" @click="goPrev"></div>

        <div class="btn-switch-right" @click="goNext"></div>

        <div class="big">
          <van-swipe ref="swipe" class="swiper" :show-indicators="false" @change="onChange">
            <van-swipe-item v-for="thumb in swiper" :key="thumb">
              <img :src="thumb" />
            </van-swipe-item>
          </van-swipe>
        </div>

        <div class="small">{{ tip }}</div>

      </div>

      <div class="btns">
        <div class="btn back" @click="back"></div>
        <div class="btn create" @click="next"></div>
      </div>

      <!-- <div class="btn-create">
        <div class="btn" @click="next"></div>
      </div> -->

    </div>
  

  </div>
  <!-- block结束 -->

  </div>

</template>

<script>
import { Swipe, SwipeItem } from "vant";
export default {
  props: [],
  data() {
    return {
      selectId: 1,
      tip: '要穿破天际的火箭',
      tips: [
        '要穿破天际的火箭',
        '不屑拿全勤奖的太阳',
        '一颗大喊大叫的跳跳糖',
        '在危险边缘试探的香蕉',
        '一幅消失的蒙娜丽莎',
        '一把有毒的蘑菇伞',
        '奇特香菜怪味面包'
      ],
      swiper: [
        require("@/images/select/s1.png"),
        require("@/images/select/s2.png"),
        require("@/images/select/s3.png"),
        require("@/images/select/s4.png"),
        require("@/images/select/s5.png"),
        require("@/images/select/s6.png"),
        require("@/images/select/s7.png")
      ],
    };
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  methods: {
    onChange(index) {
      let id = index+1;
      this.selectId = id;
      this.tip = this.tips[index]
      console.log('当前ID：' + id);
    },
    goPrev() {
      this.$refs.swipe.prev();
    },
    goNext() {
      this.$refs.swipe.next();
    },
    // 返回首页
    back() {
      this.$emit("back");
    },
    // 下一页
    next() {
      this.$emit("next", this.selectId);
    }
  },
};
</script>

<style scoped lang="less">
.choose {
  position: absolute;
  top: 18px;
  left: 135px;
  width: 475px;
  height: 82px;
  // border: 1px solid red;
}
.gka-wrap {
  width: 475px;
  height: 82px;
  .chooseanimation {
    width: 475px;
    height: 82px;
    background-image: url("../assets/sprites-choose.jpg");
    background-size: 11400px 82px;
    background-repeat: no-repeat;
    animation-name: keyframes-choose;
    animation-duration: 0.96s;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    animation-timing-function: steps(1);
  }
}

.page {
  height: 100vh;
  background: url("../images/bg.png") left bottom no-repeat;
  background-size: 750px 1500px;
  position: relative;
  overflow: hidden;
  .content-block {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1200px;
    top: 50%;
    margin-top: -600px;
  }
}
.top {
  z-index: 2;
  position: absolute;
  top: 0;
  // bottom: 80%;
  width: 751px;
  height: 209px;
  background: url("../images/title.png") no-repeat;
  background-size: 100%;
}
.main {
  z-index: 3;
  position: absolute;
  width: 100%;
  left: 0;
  right: 0;
  // bottom: 6%;
  bottom: 3%;
  margin: 0 auto;
  box-sizing: border-box;
  .bg {
    width: 589px;
    height: 860px;
    background: url("../images/bg/bg-select.png") no-repeat;
    background-size: 100%;
    margin: 0 auto 50px;
    .btn-switch-left {
      position: absolute;
      left: 30px;
      top: 400px;
      width: 77px;
      height: 82px;
      background: url("../images/btn-switch-left.png") no-repeat;
      background-size: 100%;
    }
    .btn-switch-right {
      position: absolute;
      right: 30px;
      top: 400px;
      width: 77px;
      height: 82px;
      background: url("../images/btn-switch-right.png") no-repeat;
      background-size: 100%;
    }
    .big {
      position: absolute;
      top: 300px;
      left: 182px;
      // right: 0;
      // margin: 0 auto;
      width: 390px;
      height: 290px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .swiper-slide {
        width: 390px;
        height: 290px;
        float: left;  
      }
    }
    .small {
      font-family: 'zpix';
      // border: 1px solid red;
      position: absolute;
      top: 772px;
      left: 142px;
      width: 470px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      font-size: 32px;
      color: #ffda02;
      overflow: hidden;
    }
  }

  .btns {
    // z-index: 5;
    // position: absolute;
    // bottom: 5%;
    // left: 0;
    // right: 0;
    // width: 540px;
    // height: 75px;
    width: 730px;
    height: 73px;
    box-sizing: border-box;
    padding: 0 123px;
    background: url("../images/btn-bg3.png") no-repeat center center;
    background-size: 730px 28px;

    text-align: center;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .btn {
      width: 240px;
      height: 73px;
    }
    .back {
      background: url("../images/select/btn-back.png") no-repeat;
      background-size: 100%;
    }
    .create {
      width: 237px;
      height: 72px;
      background: url("../images/select/btn-create.png") no-repeat;
      background-size: 100%;
    }
  }
  // .btn-create {
  //   width: 648px;
  //   height: 91px;
  //   background: url("../images/btn-bg.png") no-repeat center center;
  //   background-size: 648px 91px;
  //   text-align: center;
  //   margin: 0 auto;
  //   .btn {
  //     width: 299px;
  //     height: 91px;
  //     margin: 0 auto;
  //     background: url("../images/btn-create.png") no-repeat;
  //     background-size: 100%;
  //   }
  // }
}
</style>
